import { EUserRoles, TUserRoles } from '@enums/common';

export const tabsNames = {
	summary: 'Summary',
	users: 'Users',
	settings: 'Settings',
	aoSettings: 'AO Settings',
	assets: 'Assets',
	kaiAssistants: 'Kai Assistant',
	projects: 'Projects',
	aoAccess: 'AO Access',
	visibilitySettings: 'Visibility Settings',
};

export interface IGetTabs {
	isSettingsTabVisible: boolean;
	isAOSettingsTabVisible: boolean;
	isAssetsTabVisible: boolean;
	isKaiAssistantTabVisible: boolean;
	isProjectsTabVisible: boolean;
	isAOAccessTabVisible: boolean;
	isVisibilityTabVisible: boolean;
}

export const getTabs = ({
	isSettingsTabVisible,
	isAOSettingsTabVisible,
	isAssetsTabVisible,
	isKaiAssistantTabVisible,
	isProjectsTabVisible,
	isAOAccessTabVisible,
	isVisibilityTabVisible,
}: IGetTabs) => [
	{
		title: tabsNames.summary,
		value: tabsNames.summary,
		iconName: 'summaryIcon',
		isVisible: true,
	},
	{
		title: tabsNames.users,
		value: tabsNames.users,
		iconName: 'usersIcon',
		isVisible: true,
	},
	{
		title: tabsNames.settings,
		value: tabsNames.settings,
		iconName: 'settings',
		isVisible: isSettingsTabVisible,
	},
	{
		title: tabsNames.aoSettings,
		value: tabsNames.aoSettings,
		iconName: 'consistency',
		isVisible: isAOSettingsTabVisible,
	},
	{
		title: tabsNames.assets,
		value: tabsNames.assets,
		iconName: 'assets',
		isVisible: isAssetsTabVisible,
	},
	{
		title: tabsNames.kaiAssistants,
		value: tabsNames.kaiAssistants,
		iconName: 'kaiAssistant',
		isVisible: isKaiAssistantTabVisible,
	},
	{
		title: tabsNames.projects,
		value: tabsNames.projects,
		iconName: 'bag',
		isVisible: isProjectsTabVisible,
	},
	{
		title: tabsNames.aoAccess,
		value: tabsNames.aoAccess,
		iconName: 'assets',
		isVisible: isAOAccessTabVisible,
	},
	{
		title: tabsNames.visibilitySettings,
		value: tabsNames.visibilitySettings,
		iconName: 'assets',
		isVisible: isVisibilityTabVisible,
	},
];

export const backPagePath = '/admin-panel/organisations';

export const AOAccessRoleAvailability: TUserRoles[] = [
	EUserRoles.networkOperatorAssetEnquirer,
	EUserRoles.networkOperatorAssetViewer,
	EUserRoles.assetConsumerAssetEnquirer,
	EUserRoles.assetConsumerAssetViewer,
];

export const VISIBLE_ACCESS_NAME = 'Visible';
